// extracted by mini-css-extract-plugin
export default {"wrapper":"GameCard_wrapper__uIqjf","delete_text":"GameCard_delete_text__7noye","name":"GameCard_name__gkVuT","qr_wrapper":"GameCard_qr_wrapper__ritgD"};